import { ZodError, ZodTypeAny } from 'zod';

export interface ToastInterface {
  primary: (text: string) => void;
  secondary: (text: string) => void;
  negative: (error: Error) => void;
  positive: (text: string) => void;
  warning: (text: string) => void;
}

export function zodValidateField(
  schema: ZodTypeAny,
  propertyName: string,
  value: unknown,
  toasts: ToastInterface,
  skipValidationIfEmptyEnabled?: boolean,
): string | true {
  const defaultErrMsg = `${propertyName} must be valid`;
  try {
    if (skipValidationIfEmptyEnabled && !value) {
      return true;
    }

    schema.parse(value);
  } catch (e) {
    if (e instanceof ZodError) {
      const flatErr = e.flatten();
      // Usage of Set below dedupes errors to avoid duplicate messages. The join adds a comma and space between msgs instead of the default which is only comma
      return flatErr.formErrors?.length > 0
        ? `${[...new Set(flatErr.formErrors)].join(', ')}`
        : defaultErrMsg;
    }
    toasts.negative(new Error('An unexpected error occured'));
    return defaultErrMsg;
  }
  return true;
}
